export const apiPath = '/v2/attached_digital_forms';
const actionType = 'ATTACHED_DIGITAL_FORMS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
